import s from './BodyModal.module.css'
import * as Input from '../../../UI/InputNew'
import { useInputNew } from '@UI/InputNew/useInputNew'
import React, { useCallback, useEffect, useState } from 'react'
import {
  API,
  classApi,
  directionAPI,
  directionGroupApi,
  directionOrdersApi,
  usersAPI,
} from '../../../../api'
import cn from 'classnames'
import update from 'immutability-helper'
import Button from '../../../UI/Button'
import { getAvatar } from '@/helpers/getAvatar'
import { useDispatch, useSelector } from 'react-redux'
import { getRolesSD } from '@/selectors'
import { formateName } from '@/helpers/formateName'
import { useLoad } from '@/hooks/useLoad'
import { getInArr } from '@/helpers/getInArr'
import {
  billingConversion,
  billingConversionPrice,
} from '@/helpers/billingConversion'
import { SettingsService } from '@/services/SettingsService'
import { SETTINGS_TYPES } from '@/constant'
import Row from '@UI/Row'
import { InputNew } from '../../../UI/InputNew'
import { Alert, DatePicker, Select, Space } from 'antd'
import { CheckBoxLabel } from '@UI/CheckBox'
import Textarea from '../../../UI/Textarea'
import dayjs from 'dayjs'
import { useAddAlert } from '@/hooks/useAddAlert'
import classNames from 'classnames'
import CreateLearningGroup from '@pages/Admin/CourseSettings/modals/CreateLearningGroup/CreateLearningGroup'
import SelectField from '@pages/Admin/CourseSettings/components/SelectField/SelectField'
import CheckboxLabel from '@pages/Admin/CourseSettings/components/CheckboxLabel/CheckboxLabel'
import { declOfNum } from '@/helpers/declOfNum'
import { closePreloader, openPreloader } from '@store/preloaderSlice'

export const BodyModal = ({ type, ...props }) => {
  const list = {
    Name,
    Ava,
    AddPost,
    RemovePost,
    AddContract,
    AddWorkHours,
    RemoveContract,
    RemoveChildren,
    Return,
    Dismiss,
    Password,
    ChangePassword,
    RecoverPassword,
    AddDirection,
    AddClass,
    AddGroupToClass,
    PasswordChanged,
    RemoveDirection,
    AddSeminarianDirection,
    RemoveSeminarianDirection,
  }
  const Component = list[type] ?? <></>
  return <Component {...props} />
}

const Name = (props) => {
  const [errorsList, setErrorsList] = React.useState([])
  const [showErrors, setShowErrors] = React.useState(false)
  const [name, setName] = React.useState(props.state.name)
  const [bindName] = useInputNew({
    name: 'full_name',
    value: name,
    onChange: setName,
    onError: setErrorsList,
    placeholder: 'Фамилия Имя отчество',
    validate: showErrors,
    // typeValid: 'name',
    errorText: 'Заполните ФИО через пробел',
  })

  const save = () => {
    setShowErrors(true)
    if (errorsList.valid) {
      props.setState(update(props.state, { name: { $set: name } }))
      props.close()
    }
  }

  return (
    <>
      <h2 className="modal__title">Редактировать ФИО</h2>
      <div className={s.body}>
        <Input.InputNew className={s.input} {...bindName} />
      </div>
      <div className={s.footerBtn}>
        <Button name="Изменить" styles="yellow" action={save} />
      </div>
    </>
  )
}

const Ava = (props) => {
  const [file, setFile] = React.useState(props.state?.avatar_path ?? false)
  const [loading, setLoading] = React.useState(false)

  const [bindFile] = useInputNew({
    name: 'file',
    value: file,
    onChange: setFile,
    placeholder: 'Выберите файл',
    accept: '.jpg, .jpeg, .png, .svg, .gif',
  })

  const save = () => {
    setLoading(true)
    const data = new FormData()
    if (typeof file === 'object' && file !== null)
      data.append('avatar_path', file)
    else props.close()

    usersAPI.updAvatar({ id: props.state.id, data }).then((res) => {
      setLoading(false)
      const img = res?.data?.avatar_path
      if (img) {
        props.setState(update(props.state, { avatar_path: { $set: img } }))
        props.close()
      }
    })
  }

  const del = () => {
    props.setState(update(props.state, { avatar_path: { $set: false } }))
    props.close()
  }

  return (
    <>
      <h2 className="modal__title">Редактировать фото профиля</h2>
      <div className={s.body}>
        <div className={cn('ava', s.ava)}>
          <img
            src={
              typeof file === 'object'
                ? URL?.createObjectURL(file)
                : getAvatar({ avatar_path: file })
            }
            alt=""
          />
        </div>
        <Input.InputFile className={s.input} {...bindFile} />
      </div>
      <div className={s.footerBtn}>
        <Button
          name={loading ? 'Загрузка...' : 'Сохранить'}
          disable={loading}
          styles="yellow"
          action={save}
        />
        <Button name="Удалить" styles="red" disable={loading} action={del} />
      </div>
    </>
  )
}

const AddPost = (props) => {
  const [role, setRole] = React.useState('')
  const [bindSelect] = useInputNew({
    name: 'thematic',
    value: role,
    onChange: setRole,
    placeholder: 'Выберите роль',
    options: useSelector(getRolesSD).filter((i) => {
      if (i.value === 'children') return false
      if (getInArr(i.value, props?.data?.rolesName)) return false
      return true
    }),
  })

  // const { state: directionList, getState: getDirectionList } = useLoad({
  //   api: directionAPI.getAll,
  //   initState: [],
  //   key: 'data',
  //   last: false
  // })

  // React.useEffect(() => { if (role === 'seminarian') getDirectionList() }, [role])

  // const [direction, setDirection] = React.useState('')
  // const [bindDirection] = useInputNew({
  //   name: 'direction',
  //   value: direction,
  //   onChange: setDirection,
  //   placeholder: 'Выберите направление',
  //   title: 'Направление',
  //   errorText: 'Не выбрано направление',
  //   options: directionList?.map(({ id: value, name: label }) => ({ label, value })),
  //   style: { width: "100%" }
  // })

  const save = () => {
    if (role) {
      const roles = props.state.roles
      roles.push({
        item_name: role,
      })

      usersAPI
        .updateRoles({
          id: props.state.id,
          data: { roles },
        })
        .then((res) => {
          if (res.data.status === 'success') {
            // props.setState(
            //     update(props.state, { roles: { $push: [{ item_name: role }] } })
            // );

            props.addAlert({ title: 'Роль успешно добавлена' })
            props.close()
          }
        })
    } else {
      props.addAlert({ type: 'error', title: 'Не выбрана роль' })
    }
  }

  return (
    <>
      <h2 className="modal__title">Добавить должность</h2>
      <div className={s.body}>
        <Input.InputSelect className={s.input} {...bindSelect} />
        {/* {role === 'seminarian' && <Input.InputSelect {...bindDirection} />} */}
      </div>
      <div className={s.footerBtn}>
        <Button name="Добавить" styles="yellow" action={save} />
      </div>
    </>
  )
}

const RemovePost = (props) => {
  const save = () => {
    props.setState(
      update(props.state, { roles: { $splice: [[props.data, 1]] } }),
    )
    props.close()
  }
  return (
    <>
      <h2 className="modal__title">Удаление должность</h2>
      <div className={s.body}></div>
      <div className={s.footerBtn}>
        <Button name="Подтвердить действие" styles="red" action={save} />
      </div>
    </>
  )
}

const AddSeminarianDirection = (props) => {
  const getParams = () => {
    if (props?.state?.seminarianDirection?.length) {
      return {
        filter: [
          `[direction_id][nin][]=${props?.state?.seminarianDirection?.map(
            ({ id }) => id,
          )}`,
        ],
      }
    }
    return
  }

  const { state: directionList } = useLoad({
    api: directionAPI.getAll,
    params: { ...getParams() },
    initState: [],
    key: 'data',
  })

  const [direction, setDirection] = React.useState('')
  const [bindDirection] = useInputNew({
    name: 'direction',
    value: direction,
    onChange: setDirection,
    placeholder: 'Выберите направление',
    title: 'Направление',
    errorText: 'Не выбрано направление',
    options: directionList?.map(({ id: value, name: label }) => ({
      label,
      value,
    })),
    style: { width: '100%' },
  })

  const save = () => {
    if (direction) {
      usersAPI
        .addDirection({
          data: { direction_id: direction, seminarian_id: props.state.id },
        })
        .then((res) => {
          if (res.data.status === 'success') {
            props.setState((prev) => ({
              ...prev,
              seminarianDirection: [
                ...prev.seminarianDirection,
                {
                  linkId: res.data.data.id,
                  id: direction,
                  name: directionList?.find((el) => el.id === direction)?.name,
                },
              ],
            }))
            props.addAlert({ title: 'Направление успешно добавлено' })
            props.close()
          }
        })
    } else {
      props.addAlert({ type: 'error', title: 'Не выбрано направление' })
    }
  }

  return (
    <>
      <h2 className="modal__title">Добавить направление</h2>
      <div className={s.body}>
        <Input.InputSelect {...bindDirection} />
      </div>
      <div className={s.footerBtn}>
        <Button name="Добавить" styles="yellow" action={save} />
      </div>
    </>
  )
}

const RemoveSeminarianDirection = (props) => {
  const save = () => {
    if (props.data) {
      usersAPI.removeDirection({ id: props.data }).then((res) => {
        if (res.data.status === 'success') {
          afterSave()
        }
      })
    } else {
      afterSave()
    }
  }

  const saveEnter = (e) => {
    if (e.key === 'Enter') {
      save()
    }
  }

  useEffect(() => {
    document.addEventListener('keydown', saveEnter)
    return () => {
      document.removeEventListener('keydown', saveEnter)
    }
  }, [])

  const afterSave = () => {
    props.setState((prev) => ({
      ...prev,
      seminarianDirection: prev.seminarianDirection.filter(
        (el) => el.linkId !== props.data,
      ),
    }))

    props.addAlert({ title: 'Направление успешно удалено' })
    props.close()
  }

  return (
    <>
      <h2 className="modal__title">Удаление направления</h2>
      <div className={s.body}></div>
      <div className={s.footerBtn}>
        <Button name="Подтвердить действие" styles="red" action={save} />
      </div>
    </>
  )
}

const AddContract = (props) => {
  const [loading, setLoading] = React.useState(false)

  const [errorsList, setErrorsList] = React.useState([])
  const [showErrors, setShowErrors] = React.useState(false)
  const [file, setFile] = React.useState('')
  const [name, setName] = React.useState('')
  const [bindName] = useInputNew({
    name: 'file_name',
    value: name,
    onChange: setName,
    onError: setErrorsList,
    placeholder: 'Введите название файла',
    validate: showErrors,
    errorText: 'Введите название файла',
  })

  const [bindFile] = useInputNew({
    name: 'file',
    value: file,
    onChange: setFile,
    placeholder: 'Выберите файл',
    onError: setErrorsList,
    validate: showErrors,
  })

  const save = () => {
    setShowErrors(true)
    if (errorsList.valid) {
      setLoading(true)
      const formData = new FormData()
      formData.append('file', file)
      formData.append('name', name)
      formData.append('user_id', props.state.id)

      usersAPI.addContract({ data: formData }).then((res) => {
        setLoading(false)
        if (res.data.status === 'success') {
          usersAPI
            .getUser({ id: props.state.id, expand: ['contracts'] })
            .then((res) =>
              props.setState(
                update(props.state, {
                  contracts: { $set: res.data.contracts },
                }),
              ),
            )
          props.close()
        }
      })
    }
  }

  return (
    <>
      <h2 className="modal__title">Добавить договор</h2>
      <div className={s.body}>
        <Input.InputNew className={s.input} {...bindName} />
        <Input.InputFile className={s.input} {...bindFile} />
      </div>
      <div className={s.footerBtn}>
        <Button
          name={loading ? 'Загрузка...' : 'Сохранить'}
          disable={loading}
          styles="yellow"
          action={save}
        />
      </div>
    </>
  )
}

const RemoveContract = (props) => {
  const save = () => {
    usersAPI.removeContract({ id: props.data }).then((res) => {
      usersAPI
        .getUser({ id: props.state.id, expand: ['contracts'] })
        .then((res) =>
          props.setState(
            update(props.state, { contracts: { $set: res.data.contracts } }),
          ),
        )
      props.close()
    })
  }
  return (
    <>
      <h2 className="modal__title">Удалить договор</h2>
      <div className={s.body}></div>
      <div className={s.footerBtn}>
        <Button name="Подтвердить действие" styles="red" action={save} />
      </div>
    </>
  )
}

const RemoveChildren = (props) => {
  const save = () => {
    props.data.deleteChild(props.data.childrenId)
    props.close()
  }
  return (
    <>
      <h2 className="modal__title">Удалить ребенка из списка детей родителя</h2>
      <div className={s.body}></div>
      <div className={s.footerBtn}>
        <Button name="Подтвердить действие" styles="red" action={save} />
      </div>
    </>
  )
}

const Return = (props) => {
  //   const save = () => {
  //     props.close()
  //   }
  //   return <>
  //     <h2 className='modal__title'>Восстановить коллегу</h2>
  //     <div className={s.body}>
  //     </div>
  //     <div className={s.footerBtn}>
  //       <Button name='Подтвердить действие' styles='yellow' action={save} />
  //     </div>
  //   </>
}
const Dismiss = (props) => {
  //   const save = () => {
  //     props.close()
  //   }
  //   return <>
  //     <h2 className='modal__title'>Уволить коллегу</h2>
  //     <div className={s.body}>
  //     </div>
  //     <div className={s.footerBtn}>
  //       <Button name='Подтвердить действие' styles='red' action={save} />
  //     </div>
  //   </>
}

const toNumberWithDot = (text) => {
  let value = text.replace(/[^0-9.]/g, '')
  value = value.replace(/([.].*)[.]/g, '$1')
  value = value.replace(/^([.])/, '')

  return value
}

const AddDirection = (props) => {
  const addAlert = useAddAlert()
  const dateFormat = 'YYYY.MM.DD'
  const methodPUT = !!props?.data?.item?.privateInfo?.id

  const directionIds = props?.data?.directions ?? []
  const settings = SettingsService.get(SETTINGS_TYPES.GENERAL)
  const isUniversalBalance = settings?.isUniversalBalance === '1'
  const [tariffType, setTariffType] = useState()
  const [process, setProcess] = useState(() => false)
  const [courses, setCourses] = React.useState(
    props?.data?.item ? [props.data.item] : [],
  )
  // eslint-disable-next-line react-hooks/exhaustive-deps
  React.useEffect(() => {
    directionAPI
      .getAll({
        filter:
          directionIds?.length > 0
            ? [`[direction_id][nin][]=${directionIds}`]
            : [],
        expand: [
          'directionTariffs.tariffPeriods',
          'directionTariffs.tariffWeeks',
          'directionTariffs.tariffDays',
          'teacher',
        ],
      })
      .then((res) => setCourses(res?.data?.data))
  }, [])

  const initState = {
    direction: props?.data?.item?.direction_id ?? undefined,
    tariff: props?.data?.item?.tariff_id ?? '',
    sum: isUniversalBalance ? 0 : props?.data?.item?.payment_amount ?? '',
    buyHours: isUniversalBalance ? 0 : props?.data?.item?.buy_hours ?? '',
    salaryPerHour: props?.data?.item?.privateInfo?.salary_per_hour ?? '',
    hourCost: props?.data?.item?.privateInfo?.hour_cost ?? '',
    lessonPerWeek: props?.data?.item?.privateInfo?.lessons_per_week ?? '',
    timeOneLesson: props?.data?.item?.privateInfo?.time_one_lesson
      ? Math.ceil(
          parseFloat(
            (props.data.item.direction.directionTariffs?.find(
              (i) => i.id === props?.data?.item?.tariff_id ?? '',
            )?.type === 'minute'
              ? props?.data?.item?.privateInfo?.time_one_lesson * 60
              : props?.data?.item?.privateInfo?.time_one_lesson
            ).toFixed(2),
          ),
        ) ?? ''
      : '',
    teacherId: props?.data?.item?.teacher_id ?? '',
    // buyMonths: isUniversalBalance ? 0 : props?.data?.item?.buy_months ?? "",
    paidFromForDerection: String(dayjs().format(dateFormat)),
    newPaymentForDerection: false,
    paidFromDateForDerection: dayjs(),
    paidBeforeForDerection: null,
    paidBeforeDateForDerection: null,
    currency: props?.data?.item?.privateInfo?.currency ?? 'rub',
    file: '',
    group_id: null,
  }

  const onChangePaidBeforeDateForDerection = (date, dateString) => {
    setState((prevState) => ({
      ...prevState,
      paidBeforeForDerection: dateString,
      paidBeforeDateForDerection: date,
    }))
  }
  const onChangePaidFromDateForDerection = (date, dateString) => {
    setState((prevState) => ({
      ...prevState,
      paidFromForDerection: dateString,
      paidFromDateForDerection: date,
    }))
  }

  const [state, setState] = React.useState(initState)

  const tariffs = courses?.find(
    (i) => i.id === state.direction,
  )?.directionTariffs

  const getSelectedTariff = () =>
    tariffs?.find((tariff) => tariff.id === state.tariff)

  const [curseGroups, setCourseGroups] = useState([])
  const [attachedGroup, setAttachedGroup] = useState(null)
  const [createGroupModal, setCreateGroupModal] = useState(false)

  const onGroupCreated = (group) => {
    setCreateGroupModal(false)
    setCourseGroups((prev) => [
      ...prev,
      { value: group?.id?.toString(), label: group?.name },
    ])
  }

  React.useEffect(() => {
    if (!state.direction) return
    directionGroupApi
      .get({
        filter: [`[direction_id][eq]=${state.direction}`],
        expand: ['teacher'],
      })
      .then((res) => {
        setCourseGroups(
          res.data?.map(({ name, id: value, teacher }) => ({
            label: `${name} - ${formateName(teacher?.name, 'F I')}`,
            value,
          })),
        )
      })
  }, [state.direction])

  const [bindDirection] = useInputNew({
    name: 'direction',
    value: state.direction,
    onChange: (e) => {
      setState({
        ...initState,
        direction: e,
      })
      setAttachedGroup(null)
    },
    title: 'Направление',
    placeholder: 'Выберите направление',
    options:
      courses?.map(({ name: label, id: value }) => ({ label, value })) ?? [],
  })

  const findTariffType = React.useCallback(() => {
    if (props?.data?.item?.tariff_id)
      return props.data.item.direction.directionTariffs?.find(
        (i) => i.id === state.tariff,
      )?.type
    return tariffs?.find((i) => i.id === state.tariff)?.type
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.tariff])

  useEffect(() => {
    setTariffType(findTariffType())
  }, [findTariffType])

  const [bindTariff] = useInputNew({
    name: 'tariff',
    value: state.tariff,
    onChange: (e) => {
      const tariff = tariffs.find((t) => t.id === e)
      setState((prev) => ({
        ...initState,
        direction: prev.direction,
        hourCost: tariff?.first_price,
        tariff: e,
      }))
      const attachedGroup = curseGroups?.find(
        (item) => item?.value === tariff?.attached_groups,
      )
      setAttachedGroup(attachedGroup)
    },
    title: 'Тариф',
    placeholder: 'Выберите тариф',
    errorOptions: 'Выберите направление',
    options:
      tariffs?.map(({ name: label, id: value }) => ({ label, value })) ?? [],
  })

  const [bindGroup] = useInputNew({
    name: 'group',
    value: state.group_id,
    onChange: (e) => {
      if (attachedGroup) return
      setState((prev) => ({
        ...prev,
        group_id: e,
      }))
    },
    title: 'Группа',
    placeholder: 'Выберите группу',
    errorOptions: 'Выберите группу',
    options: curseGroups,
  })

  const [bindSum] = useInputNew({
    name: 'sum',
    value: state.sum,
    onChange: (e) => {
      if (!isUniversalBalance) {
        setState((prev) => ({ ...prev, sum: e.replace(/[^\d]/g, '') }))
      }
    },
    title: 'Сумма оплаты',
    placeholder: isUniversalBalance
      ? 0
      : String(
          Number(
            tariffs?.find((i) => i.id === state.tariff)?.first_price ?? 1300,
          ) * 3,
        ),
  })

  const [bindFile] = useInputNew({
    name: 'document',
    value: state.file,
    onChange: (e) => setState((prev) => ({ ...prev, file: e })),
    placeholder: 'Прикрепить',
    title: 'Прикрепите подтверждающий документ',
  })

  // const [bindMonths] = useInputNew({
  //   name: "months",
  //   value: isUniversalBalance ? 0 : state.buyMonths,
  //   onChange: (e) => {
  //     if (!isUniversalBalance) {
  //       setState((prev) => ({...prev, buyMonths: e.replace(/[^\d]/g, "")}))
  //     }
  //   },
  //   title: "Укажите количество месяцев",
  //   placeholder: "3",
  // });

  const countAllTime = billingConversion(3, {
    multipleMeaning: true,
    type: tariffType,
  })
  const [bindHours] = useInputNew({
    name: 'hours',
    value: state.buyHours,
    onChange: (e) => {
      if (!isUniversalBalance) {
        setState((prev) => {
          const hours = parseFloat(e)

          return {
            ...prev,
            buyHours: isNaN(hours) ? null : hours,
          }
        })
      }
    },
    title: `Укажите количество ${countAllTime?.measurement}`,
    placeholder: countAllTime?.replaceWithAnAlternative,
  })

  const { state: seminarian, getState: getSeminarian } = useLoad({
    api: usersAPI.getSeminarian,
    params: { direction_id: state.direction, expand: [`seminarian`] },
    last: false,
    key: 'data',
    initState: [],
  })
  // eslint-disable-next-line react-hooks/exhaustive-deps
  React.useEffect(() => {
    if (tariffType === 'hour' || tariffType === 'minute') {
      getSeminarian()

      usersAPI
        .prevDirectionOrder({
          user_id: props.state.id,
          direction_id: state.direction,
          tariff_id: state.tariff,
        })
        .then(({ data }) => {
          if (data) {
            const buyHours = parseFloat(data.buy_hours)

            setState((prev) => ({
              ...prev,
              buyHours: isNaN(buyHours) ? null : buyHours,
              // buyMonths: data.buy_months?.replace(/[^\d]/g, ""),
              sum: 0,
            }))
          }
        })
    }
  }, [tariffType])

  const [bindSelectTeacher] = useInputNew({
    errorText: 'Выберите учителя',
    name: 'teacher_id',
    onChange: (e) => {
      const selectedSeminarian = seminarian.find(
        (item) => item.seminarian_id === e,
      )
      const salaryPerHour =
        selectedSeminarian?.rate * (tariffType === 'minute' ? 1 : 60)

      setState((prev) => ({
        ...prev,
        teacherId: e,
        salaryPerHour,
      }))
    },
    options:
      seminarian?.map(({ seminarian: { name, id: value } }) => ({
        label: formateName(name, 'F I'),
        value,
      })) ?? [],
    placeholder: 'Учитель',
    title: 'Учитель',
    value: state.teacherId,
  })

  const [bindSalaryPerHour] = useInputNew({
    errorText: 'Поле не может быть пустым',
    name: 'payment_amount',
    onChange: (e) =>
      setState((prev) => ({
        ...prev,
        salaryPerHour: toNumberWithDot(e),
      })),
    placeholder: billingConversionPrice(
      Number(tariffs?.find((i) => i.id === state.tariff)?.first_price) - 300,
      tariffType,
    ),
    title: `ЗП педагога за ${
      tariffType === 'minute' ? 'минуту' : 'час'
    } занятия`,
    value: state.salaryPerHour,
  })

  const [bindHourCost] = useInputNew({
    errorText: 'Поле не может быть пустым',
    name: 'hour_cost',
    onChange: (e) =>
      setState((prev) => ({ ...prev, hourCost: toNumberWithDot(e) })),
    placeholder: billingConversionPrice(
      tariffs?.find((i) => i.id === state.tariff)?.first_price,
      tariffType,
    ),
    title: `Стоимость ${
      tariffType === 'minute' ? 'минуты' : 'часа'
    } для ребёнка`,
    value: state.hourCost,
  })

  const [bindCurrency] = useInputNew({
    errorText: 'Поле не может быть пустым',
    name: 'currency',
    onChange: (e) => setState((prev) => ({ ...prev, currency: e })),
    options: [
      { label: '₽', value: 'rub' },
      { label: '$', value: 'dollar' },
      { label: '€', value: 'euro' },
    ],
    title: `Валюта`,
    value: state.currency,
  })

  const [bindLessonPerWeek] = useInputNew({
    errorText: 'Поле не может быть пустым',
    name: 'lesson_per_week',
    onChange: (e) => setState((prev) => ({ ...prev, lessonPerWeek: e })),
    placeholder: '2',
    title: 'Кол-во уроков в неделю',
    type: 'number',
    value: state.lessonPerWeek,
  })

  const [bindTimeOneLesson] = useInputNew({
    errorText: 'Поле не может быть пустым',
    name: 'time_one_lesson',
    onChange: (e) =>
      setState((prev) => ({
        ...prev,
        timeOneLesson: e.replace(/[^.\d]/g, ''),
      })),
    placeholder: billingConversion(1.5, { type: tariffType })
      ?.replaceWithAnAlternative,
    title: `Длительность / ${tariffType === 'minute' ? 'минут' : 'час'}`,
    value: state.timeOneLesson,
  })

  const save = () => {
    if (
      [
        'month',
        'stream_custom_period',
        'stream_custom_days',
        'stream_custom_weeks',
      ]?.includes(tariffType) &&
      (state.paidFromForDerection == null ||
        state.paidFromForDerection?.length < 4 ||
        state.paidBeforeForDerection == null ||
        state.paidBeforeForDerection?.length < 4)
    ) {
      addAlert({
        type: 'error',
        title: 'Ошибка',
        text: 'Необходимо указать даты, с какого момента оплачено направление и до какого',
      })
      return
    }
    if (
      [
        'month',
        'stream_custom_period',
        'stream_custom_days',
        'stream_custom_weeks',
      ]?.includes(tariffType) &&
      Number(state.paidFromForDerection.replace(/\./gi, '')) >
        Number(state.paidBeforeForDerection.replace(/\./gi, ''))
    ) {
      addAlert({
        type: 'error',
        title: 'Ошибка',
        text: 'Дата до которой оплачено направление не может быть меньше даты оплаты',
      })
      return
    }
    if (
      [
        'stream_custom_period',
        'stream_custom_days',
        'stream_custom_weeks',
        'free',
        'month',
        'stream_one_time',
      ]?.includes(tariffType) &&
      (state?.group_id === null || state?.group_id === undefined)
    ) {
      addAlert({
        type: 'error',
        title: 'Ошибка',
        text: 'Нужно обязательно выбрать группу',
      })
      return
    }

    const data = new FormData()
    data.append('children_id', props.state.id)
    data.append('direction_id', state.direction)
    data.append('tariff_id', state.tariff)
    data.append('payment_amount', state.sum)
    data.append('status', 1)

    if (state?.group_id) {
      data.append('group_id', state.group_id)
    }

    if (
      [
        'month',
        'stream_custom_period',
        'stream_custom_days',
        'stream_custom_weeks',
      ]?.includes(tariffType)
    ) {
      data.append('paid_from', state.paidFromForDerection)
      data.append('next_payment_date', state.paidBeforeForDerection)
      data.append('new_payment', state.newPaymentForDerection)
    }
    if (tariffType === 'hour' || tariffType === 'minute') {
      data.append('new_payment', state.newPaymentForDerection)
    }

    if (state.buyHours || state.buyHours === 0) {
      data.append('buy_hours', state.buyHours)
      data.append('salary_per_hour', state.salaryPerHour ?? 0)
      data.append('hour_cost', state.hourCost ?? 0)
      data.append('lesson_per_week', state.lessonPerWeek ?? 0)
      data.append(
        'time_one_lesson',
        billingConversion(state.timeOneLesson, { type: tariffType })
          .fractionalExpression ?? 0,
      )
      data.append('currency', state.currency ?? 'rub')
    }

    state.teacherId && data.append('teacher_id', state.teacherId)

    // if (state.buyMonths || state.buyMonths === 0) {
    //   data.append("buy_months", state.buyMonths);
    // }

    if (typeof state.file === 'object') data.append('document', state.file)

    if (tariffType === 'free') {
      data.append('buy_months', 0)
      data.append('payment_amount', 0)
    }

    const updData = {
      hour_cost: state.hourCost,
      salary_per_hour: state.salaryPerHour,
      time_one_lesson: billingConversion(state.timeOneLesson, {
        type: tariffType,
      }).fractionalExpression,
      lessons_per_week: state.lessonPerWeek,
      currency: state.currency,
      teacher_id: state.teacherId,
    }

    setProcess(true)

    if (methodPUT) {
      directionOrdersApi
        .updPrivateInfo({
          data: updData,
          params: { id: props.data.item.privateInfo.id },
        })
        .then((res) => {
          if (res?.data?.status === 'success') {
            props.getDirection()
            props.close()
            addAlert({
              title: 'Курс обновлен!',
            })
          }
        })
        .finally(() => setProcess(false))
    } else {
      directionOrdersApi
        .createOrder({ data })
        .then((res) => {
          if (res?.data?.status === 'success') {
            props.getDirection()
            props.close()
            addAlert({
              title: 'Курс добавлен!',
            })
          }
        })
        .finally(() => setProcess(false))
    }
  }

  const showIsNewPay = getSelectedTariff()?.name !== 'Индивидуальный'

  useEffect(() => {
    setState((prev) => ({
      ...prev,
      group_id: attachedGroup?.value,
    }))
  }, [attachedGroup])

  const filterSort = useCallback((optionA, optionB) => {
    return (optionA?.label ?? '')
      .toLowerCase()
      .localeCompare((optionB?.label ?? '').toLowerCase())
  }, [])

  const isIndividual = ['hour', 'minute'].includes(tariffType)

  return (
    <>
      <h2 className="modal__title">
        {methodPUT ? 'Редактирование частного курса' : 'Добавить курс'}
      </h2>
      <div className={s.bodyNew}>
        {!methodPUT && (
          //<Input.InputSelect className={s.input} {...bindDirection} />
          <div className={s.selectWithLabel}>
            <div className={s.selectLabel}>Курс</div>
            <Select
              showSearch
              className={classNames(
                s.select,
                s.removeBoxShadow,
                s.customSelect,
              )}
              placeholder="Выберите курс"
              optionFilterProp="label"
              value={state.direction}
              onChange={(e) => setState({ ...initState, direction: e })}
              filterSort={filterSort}
              options={courses?.map(({ name: label, id: value }) => ({
                label,
                value,
              }))}
            />
          </div>
        )}
        {!methodPUT && (
          <div className={s.selectWithLabel}>
            <div className={s.selectLabel}>Тариф</div>
            <Select
              showSearch
              className={classNames(
                s.select,
                s.removeBoxShadow,
                s.customSelect,
              )}
              placeholder="Выберите тариф"
              optionFilterProp="label"
              value={state.tariff}
              onChange={(e) => {
                const tariff = tariffs.find((t) => t.id === e)
                setState((prev) => ({
                  ...initState,
                  direction: prev.direction,
                  hourCost: tariff?.first_price,
                  tariff: e,
                }))
                const attachedGroup = curseGroups?.find(
                  (item) => item?.value === tariff?.attached_groups,
                )
                setAttachedGroup(attachedGroup)
              }}
              filterSort={filterSort}
              options={
                tariffs?.map(({ name: label, id: value }) => ({
                  label,
                  value,
                })) ?? []
              }
            />
          </div>
        )}
        {[
          'stream_custom_period',
          'stream_custom_days',
          'stream_custom_weeks',
          'free',
          'month',
          'stream_one_time',
        ]?.includes(tariffType) && (
          <div className={s.selectWithLabel}>
            <div className={s.selectLabel}>Группа</div>
            <SelectField
              placeholder="Выберите группу"
              value={state.group_id ?? null}
              className={s.selectField}
              popupClassName={s.selectFieldPopup}
              onChange={(e) => {
                if (attachedGroup) return
                e === 'create_group'
                  ? setCreateGroupModal(true)
                  : setState((prev) => ({
                      ...prev,
                      group_id: e,
                    }))
              }}
              options={[
                { label: 'Создать группу', value: 'create_group' },
                ...curseGroups,
              ]}
            />
            {attachedGroup && (
              <div
                className={s.inputTrailingLabel}
                style={{ marginTop: '5px' }}
              >
                У Вас стоит автораспределение учащихся в данную группу,
                отключите это в настройках курса, чтобы изменить группу!
              </div>
            )}
          </div>
        )}
        {[
          'month',
          'stream_custom_period',
          'stream_custom_days',
          'stream_custom_weeks',
        ]?.includes(tariffType) && (
          <>
            {/* <Input.InputNew className={s.input} {...bindMonths} /> */}
            {isUniversalBalance ? (
              <div style={{ fontSize: '13px' }}>
                При включенным едином балансе в ЛК ученика это значение всегда 0
              </div>
            ) : (
              <></>
            )}
            {
              <CheckBoxLabel
                value={state.newPaymentForDerection}
                onClick={() => {
                  setState((prev) => ({
                    ...prev,
                    newPaymentForDerection: !prev.newPaymentForDerection,
                  }))
                }}
                label="Это новая оплата"
              />
            }
            <div className={s.selectWithLabel}>
              <div className={s.selectLabel}>Промежуток времени</div>
              <div className={s.selectDateNew}>
                <DatePicker
                  value={state.paidFromDateForDerection}
                  onChange={onChangePaidFromDateForDerection}
                  format={dateFormat}
                  placeholder="С какого числа оплачено направлени"
                  className={s.datePickerNew}
                />
                <DatePicker
                  value={state.paidBeforeDateForDerection}
                  onChange={onChangePaidBeforeDateForDerection}
                  format={dateFormat}
                  placeholder="До какого числа оплеченно направление"
                  className={s.datePickerNew}
                />
              </div>
            </div>
          </>
        )}
        {(tariffType === 'hour' || tariffType === 'minute') && (
          <>
            {/* {
              showIsNewPay &&
                <CheckBoxLabel
                    value={state.newPaymentForDerection}
                    onClick={()=>{
                      setState((prev) => ({ ...prev, newPaymentForDerection: !prev.newPaymentForDerection }))
                    }}
                    label='Это новая оплата'
                />
            } */}
            {!methodPUT && !isUniversalBalance && (
              <Input.InputNew
                className={classNames(s.input, s.removeBoxShadow)}
                {...bindHours}
              />
            )}

            {getSelectedTariff()?.any_seminarian ? (
              <Input.InputNew
                className={classNames(s.input, s.removeBoxShadow)}
                title={'Учитель'}
                value={'Любой учитель'}
                disabled
              />
            ) : (
              <div className={s.selectWithLabel}>
                <div className={s.selectLabel}>Учитель</div>
                <Select
                  showSearch
                  className={classNames(
                    s.select,
                    s.removeBoxShadow,
                    s.customSelect,
                  )}
                  placeholder="Выберите учителя"
                  optionFilterProp="label"
                  value={state.teacherId}
                  onChange={(e) => {
                    const selectedSeminarian = seminarian.find(
                      (item) => item.seminarian_id === e,
                    )
                    const salaryPerHour =
                      selectedSeminarian?.rate *
                      (tariffType === 'minute' ? 1 : 60)

                    setState((prev) => ({
                      ...prev,
                      teacherId: e,
                      salaryPerHour,
                    }))
                  }}
                  filterSort={filterSort}
                  options={
                    seminarian?.map(({ seminarian: { name, id: value } }) => ({
                      label: formateName(name, 'F I'),
                      value,
                    })) ?? []
                  }
                />
              </div>
            )}
            {!getSelectedTariff()?.any_seminarian && (
              <Input.InputNew
                className={classNames(s.input, s.removeBoxShadow)}
                {...bindSalaryPerHour}
              />
            )}
            <Input.InputNew
              id={'inputFloatIfNotRub'}
              className={classNames(s.input, s.removeBoxShadow)}
              {...bindHourCost}
            />
            <div className={s.selectWithLabel}>
              <div className={s.selectLabel}>Валюта</div>
              <Select
                showSearch
                className={classNames(
                  s.select,
                  s.removeBoxShadow,
                  s.customSelect,
                )}
                optionFilterProp="label"
                value={state.currency}
                onChange={(e) => setState((prev) => ({ ...prev, currency: e }))}
                filterSort={filterSort}
                options={[
                  { label: '₽', value: 'rub' },
                  { label: '$', value: 'dollar' },
                  { label: '€', value: 'euro' },
                ]}
              />
            </div>
            <Input.InputNew
              className={classNames(s.input, s.removeBoxShadow)}
              {...bindLessonPerWeek}
            />
            <Input.InputNew
              className={classNames(s.input, s.removeBoxShadow)}
              {...bindTimeOneLesson}
            />
          </>
        )}
        {!methodPUT && tariffType !== 'free' && !isUniversalBalance && (
          <Input.InputNew
            className={classNames(s.input, s.removeBoxShadow)}
            {...bindSum}
          />
        )}
        {/* {!methodPUT && tariffType !== "free" && (
          <Input.InputFile className={s.input} {...bindFile} />
        )} */}
        {isIndividual && (
          <CheckBoxLabel
            value={state.newPaymentForDerection}
            onClick={() => {
              setState((prev) => ({
                ...prev,
                newPaymentForDerection: !prev.newPaymentForDerection,
              }))
            }}
            label="Это новая оплата"
          />
        )}
      </div>
      <div className={s.footerBtn}>
        {/* <button onClick={props.close} className={s.buttonCancel}>
          Отмена
        </button> */}
        <Button
          name={methodPUT ? 'Обновить' : 'Добавить'}
          className={s.buttonPrimary}
          newDesign
          action={save}
          disabled={process}
        />
      </div>
      <CreateLearningGroup
        isVisible={createGroupModal}
        directionId={state.direction ?? null}
        onDismiss={() => setCreateGroupModal(false)}
        onCreate={onGroupCreated}
      />
    </>
  )
}

const AddClass = (props) => {
  const dispatch = useDispatch()
  const addAlert = useAddAlert()
  const [process, setProcess] = useState(false)
  const [classes, setClasses] = useState([])
  const [selectedClass, setSelectedClass] = useState(null)
  const [errorsList, setErrorsList] = useState([])
  const [showErrors, setShowErrors] = useState(false)
  useEffect(() => {}, [showErrors])

  // const [bindClass] = useInputNew({
  //   title: 'Класс',
  //   name: 'class',
  //   value: selectedClass?.id,
  //   onChange: (value) => {
  //     setNewPaymentForClass(false);
  //     setPaidBefore(null);
  //     setPaidBeforeDate(null);
  //     setPaidFrom(null);
  //     setPaidFromDate(null);
  //     setSelectedClass(classes.find(({id}) => id === value))
  //     setErrorsList([])
  //   },
  //   placeholder: 'Выберите класс',
  //   options: classes
  //     ?.filter(({ id }) => !getInArr(id, props.data?.selected || []))
  //     ?.map(({ title: label, id: value }) => ({ label, value })),
  // });

  const [bindAmount] = useInputNew({
    title: 'Сумма оплаты',
    name: 'amount',
    value: selectedClass?.payment_amount ?? 0,
    onChange: (amount) =>
      setSelectedClass({
        ...selectedClass,
        payment_amount: amount ?? 0,
      }),
    type: 'number',
    placeholder: 'Введите стоимость',
    onError: setErrorsList,
    validate: showErrors,
    errorText: 'Введите стоимость за один месяц занятий',
  })

  useEffect(() => {
    if (selectedClass && selectedClass?.one_pay) {
      setSelectedClass({
        ...selectedClass,
        payment_amount: Number(selectedClass.amount),
        payment_month_amount: Number(selectedClass.amount),
        month_discount: 0,
      })
    }
  }, [selectedClass?.id])

  useEffect(() => {
    classApi.index().then(({ data }) => setClasses(data.data ?? []))
  }, [])

  const [paidBefore, setPaidBefore] = useState(null)
  const [paidBeforeDate, setPaidBeforeDate] = useState(null)
  const [newPaymentForClass, setNewPaymentForClass] = useState(false)

  const onChangeDate = (date, dateString) => {
    setPaidBefore(dateString)
    setPaidBeforeDate(date)
  }

  const [paidFrom, setPaidFrom] = useState(null)
  const [paidFromDate, setPaidFromDate] = useState(null)

  const onChangePaidFrom = (date, dateString) => {
    setPaidFrom(dateString)
    setPaidFromDate(date)
  }

  const dateFormat = 'YYYY.MM.DD'

  const save = () => {
    if (
      selectedClass?.one_pay &&
      (paidFrom == null ||
        paidFrom?.length < 4 ||
        paidBefore == null ||
        paidBefore?.length < 4)
    ) {
      addAlert({
        type: 'error',
        title: 'Ошибка',
        text: 'Необходимо указать даты, с какого момента оплачен класс и до какого',
      })
      return
    }
    if (
      selectedClass?.one_pay &&
      Number(paidFrom.replace(/\./gi, '')) >
        Number(paidBefore.replace(/\./gi, ''))
    ) {
      addAlert({
        type: 'error',
        title: 'Ошибка',
        text: 'Дата до которой оплачен класс не может быть меньше даты оплаты',
      })
      return
    }
    setShowErrors(true)

    if (errorsList.valid || !selectedClass.one_pay) {
      setProcess(true)
      dispatch(
        openPreloader({ text: 'Идет добавление класса', showMenu: false }),
      )

      classApi
        .attachChildren(selectedClass.id, {
          user_id: props.state?.id,
          amount: selectedClass.payment_amount,
          month_amount: selectedClass.payment_month_amount,
          month_discount: selectedClass.month_discount,
          paid_from:
            paidFrom != null && paidFrom?.length > 3
              ? paidFrom.replace(/\./gi, '-')
              : null,
          next_payment_date:
            paidBefore != null && paidBefore?.length > 3
              ? paidBefore.replace(/\./gi, '-')
              : null,
          status_payment: selectedClass?.one_pay ? true : null,
          new_payment: newPaymentForClass,
        })
        .then((res) => {
          if (res.data?.status !== 'success') {
            props.data?.onError?.(res.response)
          } else {
            props.data?.onSuccess?.(res)
            props.close()
            addAlert({
              title: 'Класс добавлен!',
            })
          }
        })
        .finally(() => {
          dispatch(closePreloader())
          setProcess(false)
        })
    }
  }

  return (
    <>
      <h2 className="modal__title">Добавить класс/траекторию</h2>

      <div className={s.body}>
        <div className={s.selectWithLabel}>
          <div className={s.selectLabel}>Класс</div>
          <Select
            showSearch
            className={classNames(s.select, s.removeBoxShadow, s.customSelect)}
            placeholder="Выберите класс"
            optionFilterProp="label"
            value={selectedClass?.id}
            onChange={(value) => {
              const newClass = classes.find(({ id }) => id === value)
              const beforeData = newClass?.auto_access_duration
                ? dayjs().add(
                    newClass?.auto_access_duration,
                    newClass?.auto_access_unit === 'days' ? 'day' : 'month',
                  )
                : null
              const before = beforeData ? beforeData.format(dateFormat) : null

              setPaidBefore(before)
              setPaidBeforeDate(beforeData)
              setPaidFrom(dayjs().format(dateFormat))
              setPaidFromDate(dayjs())
              setSelectedClass(newClass)
              setErrorsList([])
            }}
            filterSort={(optionA, optionB) =>
              (optionA?.label ?? '')
                .toLowerCase()
                .localeCompare((optionB?.label ?? '').toLowerCase())
            }
            options={classes
              ?.filter(({ id }) => !getInArr(id, props.data?.selected || []))
              ?.map(({ title: label, id: value }) => ({ label, value }))}
          />
        </div>

        {/* <Input.InputSelect className={s.input} {...bindClass} /> */}

        {selectedClass &&
          (selectedClass?.one_pay ? (
            <>
              <div>Базовая стоимость, мес: {selectedClass.amount} ₽</div>
              <InputNew
                className={classNames(s.input, s.removeBoxShadow)}
                {...bindAmount}
              />
              <InputNew
                className={classNames(s.input, s.removeBoxShadow)}
                title="Стоимость класса (мес.)"
                name="monthPrice"
                value={selectedClass?.payment_month_amount ?? 0}
                onChange={(e) =>
                  setSelectedClass({
                    ...selectedClass,
                    payment_month_amount: e?.target?.value,
                    month_discount: 0,
                  })
                }
                type="number"
                placeholder="0"
                onError={setErrorsList}
                validate={showErrors}
                errorText="Введите стоимость за один месяц занятий"
              />
              <InputNew
                className={classNames(s.input, s.removeBoxShadow)}
                title="Скидка (мес.)"
                name="monthDiscount"
                value={selectedClass?.month_discount ?? 0}
                onChange={(e) => {
                  const value = e?.target?.value
                  if (
                    Number(value) <=
                      Number(selectedClass?.payment_month_amount) ??
                    0
                  )
                    setSelectedClass({
                      ...selectedClass,
                      month_discount: e?.target?.value,
                    })
                }}
                type="number"
                placeholder="0"
                onError={setErrorsList}
                validate={showErrors}
                errorText="Введите скидку за один месяц занятий"
              />
            </>
          ) : (
            <Alert
              message="Оплата за данный класс производится отдельно по каждому направлению"
              type="info"
            />
          ))}
        {selectedClass && selectedClass?.one_pay && (
          <div style={{ width: '100%' }}>
            <CheckBoxLabel
              value={newPaymentForClass}
              onClick={() => {
                setNewPaymentForClass((prev) => !prev)
              }}
              style={{ marginBottom: '10px' }}
              label="Это новая оплата"
            />
            <div className={s.selectWithLabel}>
              <div className={s.selectLabel}>Промежуток времени</div>
              <div className={s.selectDateNew}>
                <DatePicker
                  value={paidFromDate}
                  onChange={onChangePaidFrom}
                  format={dateFormat}
                  placeholder="С какого числа оплачен класс"
                  className={s.datePickerNew}
                />
                <DatePicker
                  value={paidBeforeDate}
                  onChange={onChangeDate}
                  format={dateFormat}
                  placeholder="До какого числа оплачен класс"
                  className={s.datePickerNew}
                />
              </div>
            </div>
          </div>
        )}
      </div>

      <div className={s.footerBtn}>
        {/* <button onClick={props.close} className={s.buttonCancel}>
          Отмена
        </button> */}
        <Button
          name={'Добавить'}
          action={save}
          disable={process || !selectedClass}
          loading={process}
          newDesign
          className={s.buttonPrimary}
        />
      </div>
    </>
  )
}

const AddGroupToClass = (props) => {
  const [process, setProcess] = useState(false)
  const [groups, setGroups] = useState([])
  const [selectedGroup, setSelectedGroup] = useState(null)

  const [bindGroup] = useInputNew({
    name: 'class',
    value: selectedGroup,
    onChange: setSelectedGroup,
    title: 'Группа',
    placeholder: 'Выберите группу',
    options: groups
      ?.filter(({ id, direction }) =>
        props?.data?.filterByDirection
          ? !getInArr(direction.id, props.data?.selected || [])
          : !getInArr(id, props.data?.selected || []),
      )
      ?.map(({ name: label, id: value }) => ({ label, value })),
  })

  useEffect(() => {
    classApi
      .show(props.data.classId)
      .then(({ data }) => setGroups(data.data.groups ?? []))
  }, [])

  const save = () => {
    setProcess(true)

    classApi
      .attachUserClassGroup(props.data.classId, {
        user_id: props.state?.id,
        group_id: selectedGroup,
      })
      .then((res) => {
        if (res.response?.status >= 400) {
          props.data?.onError?.(res.response)
        } else {
          props.data?.onSuccess?.(res)
          props.close()
        }
      })
      .finally(() => setProcess(false))
  }

  return (
    <>
      <h2 className="modal__title">Добавить группу</h2>

      <div className={s.body}>
        <Input.InputSelect className={s.input} {...bindGroup} />
      </div>

      <div className={s.footerBtn}>
        <Row>
          <Button
            name={'Добавить'}
            styles="yellow"
            action={save}
            disable={process || !selectedGroup}
            loading={process}
          />
          <Button name={'Отмена'} action={props.close} />
        </Row>
      </div>
    </>
  )
}

const ChangePassword = (props) => {
  const [errorsList, setErrorsList] = React.useState([])
  const [showErrors, setShowErrors] = React.useState(false)

  const [oldPassword, setOldPassword] = React.useState()
  const [bindOldPassword] = useInputNew({
    name: 'oldPassword',
    value: oldPassword,
    onChange: setOldPassword,
    onError: setErrorsList,
    placeholder: 'Введите старый пароль',
    validate: showErrors,
    type: 'password',
    errorText: 'Заполните старый пароль',
  })

  const [password, setPassword] = React.useState()
  const [bindPassword] = useInputNew({
    name: 'password',
    value: password,
    onChange: setPassword,
    onError: setErrorsList,
    placeholder: 'Введите новый пароль',
    validate: showErrors,
    type: 'password',
    errorText: 'Заполните пароль',
  })

  const [passwordRepeat, setPasswordReplay] = React.useState('')
  const [showErrorReplay, setShowErrorReplay] = React.useState(false)
  const [bindPasswordReplay] = useInputNew({
    name: 'password_replay',
    value: passwordRepeat,
    onChange: setPasswordReplay,
    onError: setErrorsList,
    placeholder: 'Повторите новый пароль',
    validate: showErrorReplay,
    type: 'password',
    errorText: 'Пароли не совпадают',
    typeValid: (val) => val !== password,
    onBlur: () => setShowErrorReplay(true),
  })

  const save = () => {
    setShowErrors(true)
    if (errorsList.valid) {
      const data = {
        currentPassword: oldPassword,
        newPassword: password,
        passwordRepeat: passwordRepeat,
      }
      usersAPI.changePassword({ id: props.state.id, data }).then((res) => {
        if (res.data?.data?.id !== undefined) props.setModal('PasswordChanged')
      })
    }
  }

  return (
    <>
      <h2 className="modal__title">Изменить пароль</h2>
      <div className={s.body}>
        <Input.InputNew className={s.input} {...bindOldPassword} />
        <Input.InputNew className={s.input} {...bindPassword} />
        <Input.InputNew className={s.input} {...bindPasswordReplay} />

        <button
          className={s.link}
          onClick={() => props.setModal('RecoverPassword')}
        >
          Восстановить пароль
        </button>
      </div>
      <div className={s.footerBtn}>
        <Button name="Изменить" styles="yellow" action={save} />
      </div>
    </>
  )
}

const PasswordChanged = (props) => {
  const save = () => props.close()
  return (
    <>
      <h2 className="modal__title">Пароль изменён!</h2>
      <div className={s.body}></div>
      <div className={s.footerBtn}>
        <Button name="Хорошо" styles="yellow" action={save} />
      </div>
    </>
  )
}

const RecoverPassword = (props) => {
  const [status, setStatus] = React.useState(null)
  const [error, setError] = React.useState(null)
  const [customPassword, setCustomPassword] = React.useState(false)
  const [newPassword, setNewPassword] = React.useState(null)
  const save = () => props.close()
  const recover = () => {
    usersAPI
      .resetPassword({
        id: props.state.id,
        data: { custom_password: customPassword, password: newPassword },
      })
      .then((res) => {
        setStatus(res?.data?.status ?? res?.response?.data?.status)
        setError(res?.data?.error ?? res?.response?.data?.error ?? null)
      })
  }
  return (
    <>
      <h2 className="modal__title">Восстановить пароль</h2>
      <div className={s.body}>
        <div>
          <div className={s.row}>
            <CheckBoxLabel
              value={customPassword}
              onClick={() => setCustomPassword(!customPassword)}
              label="Задать новый пароль вручную"
            />
          </div>
          {customPassword && (
            <InputNew
              title={'Введите новый пароль'}
              style={{ marginTop: '1rem' }}
              onChange={(e) => setNewPassword(e.target.value)}
            ></InputNew>
          )}
        </div>
        <p>
          {status === null
            ? 'Нажмите кнопку отправить для сброса пароля'
            : status === 'error'
            ? error ?? 'Невозможно сбросить пароль'
            : 'Пароль успешно сброшен. Новый пароль отправлен на почту.'}
        </p>
      </div>
      <div className={s.footerBtn}>
        {status ? (
          <Button name="Хорошо" styles="yellow" action={save} />
        ) : (
          <>
            <Button name="Отправить" styles="yellow" action={recover} />
            <Button name="Отмена" styles="yellow" action={save} />
          </>
        )}
      </div>
    </>
  )
}

const Password = (props) => {
  const [password, setPassword] = React.useState()
  const [bindPassword] = useInputNew({
    name: 'password',
    value: password,
    onChange: setPassword,
    placeholder: 'Введите новый пароль',
    errorText: 'Заполните пароль',
  })

  const save = () => props.close()
  return (
    <>
      <h2 className="modal__title">Изменить пароль</h2>
      <div className={s.body}>
        <Input.InputNew className={s.input} {...bindPassword} />
      </div>
      <div className={s.footerBtn}>
        <Button name="Сохранить" styles="yellow" action={save} />
      </div>
    </>
  )
}

const RemoveDirection = (props) => {
  const [disabledByStudent, setDisabledByStudent] = useState(false)
  const [disableComment, setDisableComment] = useState('')

  const save = () => {
    const sendData = {
      disabled_by_student: disabledByStudent,
      disable_comment: disabledByStudent ? disableComment : '',
    }

    directionOrdersApi
      .remove({ id: props.data }, { data: sendData })
      .then((res) => {
        props.getDirection()
        props.close()
      })
  }

  const saveEnter = (e) => {
    if (e.key === 'Enter') {
      save()
    }
  }

  useEffect(() => {
    document.addEventListener('keydown', saveEnter)
    return () => {
      document.removeEventListener('keydown', saveEnter)
    }
  }, [])

  return (
    <>
      <h2 className="modal__title">Удалить направление</h2>
      <div className={s.body}>
        <CheckBoxLabel
          value={disabledByStudent}
          onClick={() => setDisabledByStudent((prevValue) => !prevValue)}
          label="Учащийся слился с обучения"
        />
        {disabledByStudent && (
          <div style={{ width: '100%' }}>
            <span
              style={{
                fontSize: '15px',
                marginBottom: '10px',
                display: 'flex',
              }}
            >
              Напишите причину слива учащегося
            </span>
            <Textarea
              value={disableComment}
              onChange={(e) => setDisableComment(e.target.value)}
              placeholder="Причина слива учащегося"
              style={{ width: '100%' }}
            />
          </div>
        )}
      </div>
      <div className={s.footerBtn}>
        <Button name="Подтвердить действие" styles="red" action={save} />
      </div>
    </>
  )
}

const AddWorkHours = (props) => {
  const [loading, setLoading] = React.useState(false)

  const [errorsList, setErrorsList] = React.useState([])
  const [showErrors, setShowErrors] = React.useState(false)
  const [startTime, setStartTime] = React.useState('')
  const [endTime, setEndTime] = React.useState('')
  const [weekDay, setWeekDay] = React.useState('')

  const daysOfWeek = [
    { label: 'Понедельник', value: 0 },
    { label: 'Вторник', value: 1 },
    { label: 'Среда', value: 2 },
    { label: 'Четверг', value: 3 },
    { label: 'Пятница', value: 4 },
    { label: 'Суббота', value: 5 },
    { label: 'Воскресение', value: 6 },
  ]

  const [bindStartTime] = useInputNew({
    name: 'start_time',
    type: 'time',
    value: startTime,
    onChange: setStartTime,
    onError: setErrorsList,
    placeholder: 'Время начала',
    validate: showErrors,
    errorText: 'Введите время начала',
  })

  const [bindEndTime] = useInputNew({
    name: 'end_time',
    type: 'time',
    value: endTime,
    onChange: setEndTime,
    placeholder: 'Время окончания',
    onError: setErrorsList,
    validate: showErrors,
    errorText: 'Введите время окончания',
  })

  const [bindWeekDay] = useInputNew({
    name: 'week_day',
    value: weekDay,
    onChange: setWeekDay,
    options: daysOfWeek,
    onError: setErrorsList,
    validate: showErrors,
    errorText: 'Выберите день недели',
  })

  const save = () => {
    setShowErrors(true)
    if (errorsList.valid) {
      // setLoading(true);
      const formData = new FormData()
      formData.append('start_time', startTime)
      formData.append('end_time', endTime)
      formData.append('week_day', weekDay)
      formData.append('user_id', props.state.id)
      API({
        url: 'work-hours/create',
        data: formData,
        method: 'POST',
      }).then((res) => {
        setLoading(false)
        if (res?.status == 200 || res?.data?.status === 'success') {
          props.addAlert({ title: 'Часы успешно добавлены' })
          props.close()
          window.location.reload()
        } else {
          props.addAlert({ type: 'error', title: res?.response?.data?.error })
          props.close()
        }
      })
    }
  }

  return (
    <>
      <h2 className="modal__title">Добавить часы работы</h2>
      <div className={s.body}>
        <label>День недели</label>
        <Input.InputSelect className={s.input} {...bindWeekDay} />
        <label>Время начала</label>
        <Input.InputNew className={s.input} {...bindStartTime} />
        <label>Время окончания</label>
        <Input.InputNew className={s.input} {...bindEndTime} />
      </div>
      <div className={s.footerBtn}>
        <Button
          name={loading ? 'Загрузка...' : 'Сохранить'}
          disable={loading}
          styles="yellow"
          action={save}
        />
      </div>
    </>
  )
}
